export type AuthLogoutEvents = Record<EXECUTE_LOGOUT, void>;

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum EXECUTE_LOGOUT {
  request = 'auth/EXECUTE_LOGOUT/request',
  success = 'auth/EXECUTE_LOGOUT/success',
  failure = 'auth/EXECUTE_LOGOUT/failure',
  cancel = 'auth/EXECUTE_LOGOUT/cancel',
}
